import { render, staticRenderFns } from "./RenamePortfolioModal.vue?vue&type=template&id=0b1f6ea5"
import script from "./RenamePortfolioModal.vue?vue&type=script&lang=ts"
export * from "./RenamePortfolioModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports